import React from 'react';
import App from './App';
import { createRoot } from 'react-dom/client';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import configureStore from './redux';
import i18n from './i18n';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { QueryProvider } from 'services/Providers/QueryProvider';

export const store = configureStore();
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <QueryProvider>
        <App />
      </QueryProvider>
    </Provider>
  </I18nextProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorkerRegistration.register();
